// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3xjKf","footer":"ModalFilter_footer__ZT55S"};